var _rect, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInteligenciaVendasIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4.54545,
    fill: "#E0F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 37.5L12.5 12.5C12.5 11.9875 12.925 11.5625 13.4375 11.5625C13.95 11.5625 14.375 11.9875 14.375 12.5L14.375 37.5C14.375 38.0125 13.95 38.4375 13.4375 38.4375C12.925 38.4375 12.5 38.0125 12.5 37.5Z",
    fill: "url(#paint0_linear_920_3105)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22.1875L12.5 22.1875L12.5 27.8125L35 27.8125C36.375 27.8125 37.5 27.25 37.5 25.5625L37.5 24.4375C37.5 22.75 36.375 22.1875 35 22.1875Z",
    fill: "url(#paint1_linear_920_3105)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 13.75L12.5 13.75L12.5 18.75L27.5 18.75C28.875 18.75 30 18.25 30 16.75L30 15.75C30 14.25 28.875 13.75 27.5 13.75Z",
    fill: "url(#paint2_linear_920_3105)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 31.25L12.5 31.25L12.5 36.25L21.25 36.25C22.625 36.25 23.75 35.75 23.75 34.25L23.75 33.25C23.75 31.75 22.625 31.25 21.25 31.25Z",
    fill: "url(#paint3_linear_920_3105)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_920_3105",
    x1: 13.4375,
    y1: 11.5625,
    x2: 13.4375,
    y2: 38.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26D0CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_920_3105",
    x1: 25,
    y1: 22.1875,
    x2: 25,
    y2: 27.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26D0CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_920_3105",
    x1: 21.25,
    y1: 13.75,
    x2: 21.25,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26D0CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_920_3105",
    x1: 18.125,
    y1: 31.25,
    x2: 18.125,
    y2: 36.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26D0CE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteligenciaVendasIcon);
export default __webpack_public_path__ + "static/media/inteligencia-vendas-icon.dd62e9339b8320ee2a7043bc44ff33e6.svg";
export { ForwardRef as ReactComponent };